var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1667 42.7083V76.875C75.1667 78.2342 74.6267 79.5378 73.6656 80.4989C72.7045 81.46 71.4009 82 70.0417 82H5.125C3.76577 82 2.4622 81.46 1.50108 80.4989C0.539953 79.5378 0 78.2342 0 76.875V11.9583C0 10.5991 0.539953 9.29553 1.50108 8.33441C2.4622 7.37329 3.76577 6.83333 5.125 6.83333H39.2917C39.7447 6.83333 40.1793 7.01332 40.4996 7.33369C40.82 7.65407 41 8.08859 41 8.54167C41 8.99475 40.82 9.42927 40.4996 9.74964C40.1793 10.07 39.7447 10.25 39.2917 10.25H5.125C4.67192 10.25 4.2374 10.43 3.91703 10.7504C3.59665 11.0707 3.41667 11.5053 3.41667 11.9583V76.875C3.41667 77.3281 3.59665 77.7626 3.91703 78.083C4.2374 78.4034 4.67192 78.5833 5.125 78.5833H70.0417C70.4947 78.5833 70.9293 78.4034 71.2496 78.083C71.57 77.7626 71.75 77.3281 71.75 76.875V42.7083C71.75 42.2553 71.93 41.8207 72.2504 41.5004C72.5707 41.18 73.0053 41 73.4583 41C73.9114 41 74.3459 41.18 74.6663 41.5004C74.9867 41.8207 75.1667 42.2553 75.1667 42.7083ZM82 13.6667C82 16.3697 81.1985 19.012 79.6968 21.2595C78.195 23.5069 76.0606 25.2586 73.5633 26.293C71.0661 27.3274 68.3182 27.5981 65.6671 27.0707C63.016 26.5434 60.5809 25.2418 58.6695 23.3305C56.7582 21.4191 55.4566 18.984 54.9293 16.3329C54.4019 13.6818 54.6726 10.9339 55.707 8.43666C56.7414 5.9394 58.4931 3.80496 60.7405 2.30325C62.988 0.801535 65.6303 0 68.3333 0C71.958 0 75.4341 1.43988 77.9971 4.00287C80.5601 6.56587 82 10.042 82 13.6667ZM78.5833 13.6667C78.5833 11.6394 77.9822 9.65768 76.8559 7.97207C75.7296 6.28647 74.1288 4.9727 72.2558 4.1969C70.3829 3.4211 68.322 3.21812 66.3337 3.61362C64.3454 4.00912 62.519 4.98533 61.0855 6.41882C59.652 7.85231 58.6758 9.67869 58.2803 11.667C57.8848 13.6553 58.0878 15.7162 58.8636 17.5892C59.6394 19.4621 60.9531 21.0629 62.6387 22.1892C64.3243 23.3155 66.3061 23.9167 68.3333 23.9167C71.0518 23.9167 73.6589 22.8368 75.5812 20.9145C77.5034 18.9923 78.5833 16.3851 78.5833 13.6667Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 40,
    height: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 32,
    width: 5,
    height: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 45,
    width: 40,
    height: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 45,
    width: 5,
    height: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 58,
    width: 40,
    height: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 58,
    width: 5,
    height: 5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.4658cdbee15319062138d8717ae01513.svg";
export { ForwardRef as ReactComponent };